import { curry, memoizeWith as memoizeWithR } from 'ramda';

export const memoizeWith = curry(memoizeWithR);